import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { applyFilter } from '../../actions/app/filter.actions'
import { pushTrackingEvent } from '../../actions/tracking/tracking.actions'
import viewTrackingFilterAttributesSelector from '../../selectors/tracking/viewTrackingFilterAttributesSelector'
import filtersSelector from '../../selectors/filtersSelector'

const getStandardFilterName = (identifier: string, trackingFilters: any[]): string | null => {
    const filter = trackingFilters.find(f => f.identifier === identifier)
    return filter?.attribute || null
}

const trackAttributeFilterMiddleware: Middleware = (store) => (next) => (action) => {
    next(action)

    if (isActionOf(applyFilter, action)) {
        const { id, value } = action.payload
        
        const state = store.getState()
        const trackingFilters = viewTrackingFilterAttributesSelector(state)
        
        const standardName = getStandardFilterName(id, trackingFilters)
        if (!standardName) {
            return
        }

        const currentFilters = filtersSelector(state)
        
        const relatedFilters = trackingFilters
            .map(trackingFilter => ({
                id: trackingFilter.attribute,
                values: currentFilters[trackingFilter.identifier] || [],
            }))
            .filter(filter => filter.values.length > 0)
        
        const dataLayerEvent = {
            eventInfo: {
                eventAction: 'content',
                eventName: 'dcc carline filter',
            },
            attributes: {
                componentName: 'filter',
                label: standardName,
                currentURL: window.location.href,
                targetURL: '',
                clickID: '',
                elementName: 'dropdown',
                value: String(value),
                pos: 'carline',
                relatedFilters,
            },
        }

        store.dispatch(pushTrackingEvent(dataLayerEvent))
    }
}

export default trackAttributeFilterMiddleware
